import { all } from 'common';
import { appSaga, crmSaga, homeSaga, notificationSaga, roomSaga, userSaga } from 'redux/saga';

export const rootSaga = function* rootSaga() {
  yield* all([homeSaga(), appSaga(), roomSaga(), userSaga(), notificationSaga(), crmSaga()]);
};
